module.exports = __webpack_public_path__ + "img/PMK_20241105_1.691558a5.jpg";